<template>
  <div class="home" style="height: 100vh; position: relative; overflow: hidden">
    <div class="login-container flip-animation">
      <div class="welcome-section">
        <el-image
          :src="imageUrl"
          style="width: 70px; height: 70px; border-radius: 20px"
        >
        </el-image>
        <h2 style="font-size: 24px; color: white">楼宇设备数字移交平台</h2>
        <span>铂诺客智能科技（北京）有限公司</span>
        <p>Smart Equipment Management Platform</p>
      </div>
      <div class="login-section">
        <h3>欢迎，请登录系统</h3>
        <el-form
          ref="ruleForm1"
          :model="ruleForm1"
          @submit.native.prevent
          label-width="70px"
          label-position="left"
          v-loading="loading"
        >
          <el-form-item prop="Number" label="用户名">
            <el-input
              v-model="ruleForm1.Number"
              auto-complete="off"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="Cipher" label="密码">
            <el-input
              v-model="ruleForm1.Cipher"
              auto-complete="off"
              placeholder="请输入密码"
              type="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align-last: left">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
            <!-- <el-link style="float: right">忘记密码?</el-link> -->
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="loginForm"
              style="width: 100%"
              :loading="loading"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <p>
        <span style="font-weight: bold">ICP备案号：</span
        ><span style="margin-right: 20px">京ICP备2021033771号</span>
        <span style="font-weight: bold"
          >技术支持<i class="el-icon-phone" style="color: red"></i>：</span
        ><span>13120268450</span>
      </p>
      <p>
        <span style="font-weight: bold">Copyright &copy;</span
        ><span style="margin-right: 20px"
          >2021-{{ new Date().getFullYear() }}</span
        >
        <span style="font-weight: bold">版权所有：</span
        ><span>铂诺客智能科技（北京）有限公司</span>
      </p>
    </div>
  </div>
</template>

<script>
import OperatorCache from '@/utils/cache/OperatorCache'
import TokenCache from '@/utils/cache/TokenCache'
import { mapState } from 'vuex'

import '@/assets/Index/index.css'

let checkLoginPhone = (rule, value, callback) => {
  // 检查是否包含中文字符
  let chineseReg = /[\u4e00-\u9fa5]/
  if (chineseReg.test(value)) {
    callback(new Error('不能输入中文字符'))
  } else {
    callback()
  }
}

export default {
  name: 'Index',
  props: ['centerDialogVisibleSecond'],

  data() {
    // 登录
    const validatecip = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm1.checkPass !== '') {
          this.$refs.ruleForm1.validateField('checkPass')
        }
        callback()
      }
    }

    return {
      imageUrl: require('@/assets/logo.png'), //icon路径
      loading: false,

      ruleForm1: {
        Number: '',
        Cipher: '',
      },
      rules1: {
        Number: [
          {
            required: true,
            message: '请输入正确的用户名/手机号',
            validator: checkLoginPhone,
            trigger: 'blur',
          },
        ],
        Cipher: [
          {
            validator: validatecip,
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
      },

      checked: true,
    }
  },
  methods: {
    getTitle() {
      return process.env.VUE_APP_ProjectName
    },

    // 保存登录信息到本地存储
    saveLoginInfo() {
      if (this.checked) {
        localStorage.setItem('rememberedUsername', this.ruleForm1.Number)
        localStorage.setItem('rememberedPassword', this.ruleForm1.Cipher)
        localStorage.setItem('rememberPassword', 'true')
      } else {
        localStorage.removeItem('rememberedUsername')
        localStorage.removeItem('rememberedPassword')
        localStorage.setItem('rememberPassword', 'false')
      }
    },

    // 从本地存储恢复登录信息
    restoreLoginInfo() {
      const rememberPassword = localStorage.getItem('rememberPassword')
      if (rememberPassword === 'true') {
        const savedUsername = localStorage.getItem('rememberedUsername')
        const savedPassword = localStorage.getItem('rememberedPassword')
        if (savedUsername && savedPassword) {
          this.ruleForm1.Number = savedUsername
          this.ruleForm1.Cipher = savedPassword
          this.checked = true
        }
      }
    },

    loginForm() {
      if (!this.ruleForm1.Number) {
        return this.$notify.warning('请输入用户名')
      }
      if (!this.ruleForm1.Cipher) {
        return this.$notify.warning('请输入密码')
      }
      this.loading = true
      this.$http
        .post('/Base_Manage/Home/AppSubmitLogin', {
          userName: this.ruleForm1.Number,
          password: this.ruleForm1.Cipher,
        })
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            // 保存登录信息
            this.saveLoginInfo()
            TokenCache.setToken(res.Data)
            await this.$store.dispatch('getUserInfo')
            await this.$store.dispatch('setUser', true)
            this.$router.replace({ path: '/ProjectView' })
          } else {
            this.$notify.error(res.Msg)
          }
        })
        .catch(() => {
          this.loading = false
          this.$notify.error('登录失败，请检查网络连接')
        })
      // this.$refs.ruleForm1.validate((valid) => {
      //   if (!valid) {
      //     return
      //   }

      // })
    },

    handleLogout() {
      const that = this
      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          TokenCache.deleteToken()
          OperatorCache.clear()
          location.reload()
          that.$router.replace({ path: '/Home/Index' })
        },
      })
    },
  },

  mounted() {
    // 页面加载时恢复保存的登录信息
    this.restoreLoginInfo()
  },

  computed: {
    ...mapState(['userInfo', 'isLogin']),
  },
}
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 888;
  width: 100%;
  text-align: center;
  // background-color: #ffffff;
  /* 设置背景色 */
  padding: 8px 0;
  /* 设置内边距 */
  font-size: 14px;
  /* 设置字体大小 */
  color: #fff;
  /* 设置字体颜色 */
}

.home {
  background: url('~@/assets/bg.jpg') no-repeat center center fixed; // 确保路径正确并设置背景属性
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.login-container {
  display: flex;
  width: 800px;
  height: 500px; /* 设置固定高度 */
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  transform-style: preserve-3d;
  animation: flipIn 1s ease-out forwards;
}

.welcome-section {
  flex: 1;
  background-color: #409eff; // 调整背景色为与登录按钮一致的蓝色
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  color: white;
  & > * {
    margin-bottom: 10px;
  }
}

.welcome-section h2 {
  margin-top: 10px; // 适当调整顶部外边距以提高位置
}

.login-section {
  flex: 1;
  background-color: #ffffff; /* 右侧纯白 */
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  & > * {
    margin-bottom: 20px;
  }
}

@keyframes flipIn {
  from {
    transform: rotateY(-90deg);
    opacity: 0;
  }
  to {
    transform: rotateY(0);
    opacity: 1;
  }
}
</style>
